export default __webpack_public_path__ + "static/media/MUNDO_HISPANICO.747e340f.png";